import Grid from '@mui/material/Grid';
import GreenButton from '../../components/buttons/green-button';
import { useTranslation } from 'react-multi-lang';
import { useState, useContext } from 'react';
import {
  ClientsMenu,
  SuppliersMenu,
} from '../../components/PredefinedMenus/PredefinedMenus';
import { useNotification } from '../../services/usenotification';
import { Divider } from '@mui/material';

import { InputField } from '../../components/FormElements/FormElements';
import { havePermission } from '../../services/hoc/permissions';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
export default () => {
  const t = useTranslation();
 
 
  const { alert } = useNotification();
  const {isMobile} = useContext(SettingContext)
  const [control, setControl] = useState({
    start_date: '',
    end_date: '',
    client: { value: 0, label: '', phoneNumber: '', address: '' },
    supplier: { value: 0, label: '', phoneNumber: '', address: '' },
  });
 const router = (router: string) => {
    if (havePermission('Show Report')){
    window.open(
      `spreedsheet` +
        `/${router}/${control.start_date}/${control.end_date}` +
        `${control.client.value && router ==='getclientReport'? `/${control.client.value}` : ''}` +
        `${control.supplier.value && router ==='getSupplierReport' ? `/${control.supplier.value}` : ''}`,
    );
    }
    else {
      let message=t('no_show_permission')
      alert({en:message,ar:message},'info')
    }
  };

  return (
    <Grid container paddingBottom={4} paddingTop={2} paddingX={2}>
      <Grid  container size={10} rowGap={3}>
        <Grid  container size={12} rowGap={1}>
          <Grid  container columnGap={1} size={10}>
            <Grid size={12}>
              <h2 style={{fontSize:isMobile?'1rem':'1.5em'}}> {t('choose_date')}</h2>
            </Grid>
            <Grid size={{sm:5,xs:12}} display={'flex'} flexDirection={'column'}>
              <label
                htmlFor="start_date"
                style={{ fontSize:isMobile?'10px': '20px', fontWeight: 'bold' }}>
                {t('from')}
              </label>
              <InputField
                style={{ width: '100%' }}
                id="start_date"
                type={'date'}
                value={control.start_date}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setControl((pre) => ({ ...pre, start_date: e.target.value }))
                }
              />
            </Grid>
            <Grid size={{sm:5,xs:12}} display={'flex'} flexDirection={'column'}>
              <label
                htmlFor="end_date"
                style={{ fontSize: isMobile?'10px': '20px', fontWeight: 'bold' }}>
                {t('to')}
              </label>
              <InputField
                style={{ width: '100%' }}
                type={'date'}
                value={control.end_date}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setControl((pre) => ({ ...pre, end_date: e.target.value }))
                }
                id={'end_date'}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid  container rowGap={1} columnGap={1} size={12}
        sx={{columnGap:{sm:1,xs:0}}}>
          <Grid size={{xs:6,sm:5}} >
            <GreenButton
              label={t('sales_report')}
              fun={() => router('getSalesReport')}
              fullWidth={true}
              disabled={ !Boolean(control.end_date) || !Boolean(control.start_date)}
            />
          </Grid>

          <Grid size={{xs:6,sm:5}}>
            <GreenButton
              label={t('purchases_report')}
              fun={() => router('getPurchaseReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) || !Boolean(control.start_date)
              }></GreenButton>
          </Grid>

          <Grid  container size={{xs:6,sm:5}}>
            <GreenButton
              label={t('print_inventory_report')}
              fun={() => router('getInventoryReport')}
              fullWidth={true}
              disabled={ !Boolean(control.end_date) || !Boolean(control.start_date)}
            />
          </Grid>
          <Grid  size={{xs:6,sm:5}}>
            <GreenButton
              label={t('print_box_flow')}
              fun={() => router('getProductionReport')}
              fullWidth={true}
              disabled={!Boolean(control.end_date) || !Boolean(control.start_date)}
            />
          </Grid>
        </Grid>
        <Grid  container size={12}>
          <Divider
            variant="fullWidth"
            sx={{ height: '1px', width: '80%', background: 'lightgray' }}
          />
        </Grid>
        <Grid  container size={12} rowGap={1} 
        sx={{columnGap:{sm:1,xs:0}}}>
          <Grid size={{xs:3,sm:5}} >
            <GreenButton
              label={t('print_client_account')}
              fun={() => router('getclientReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) ||
                !Boolean(control.start_date) ||
                !Boolean(control.client.value)
              }
            />
          </Grid>
          <Grid size={{xs:9,sm:5}} >
            <ClientsMenu
              value={control.client.value ? control.client : null}
              onChange={(selected: {
                value: number;
                label: string;
                phoneNumber: string;
                address: string;
              }) => {
                setControl((pre) => ({ ...pre, client: selected }));
              }}
              placeholder={t('select_client')}
            />
          </Grid>
          <Grid size={{xs:3,sm:5}} >
            <GreenButton
              label={t('print_supplier_account')}
              fun={() => router('getSupplierReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) ||
                !Boolean(control.start_date) ||
                !Boolean(control.supplier.value)
              }
            />
          </Grid>
          <Grid size={{sm:5,xs:9}} >
            <SuppliersMenu
              value={control.supplier.value ? control.supplier : null}
              onChange={(selected: {
                value: number;
                label: string;
                phoneNumber: string;
                address: string;
              }) => {
                setControl((pre) => ({ ...pre, supplier: selected }));
              }}
              placeholder={t('select_supplier')}
            />
          </Grid>
          {/* <Grid item xs={4}>
                        <GreenButton 
                        label={t('orders_without_bills')}
                        fun={()=>{}}
                        fullWidth={true}
                        disabled={true}
                        />
                    </Grid> */}
          {/* <Grid item xs={4}>
                        <GreenButton 
                        label={t('orders_without_operate_order')}
                        fun={()=>{}}
                        fullWidth={true}
                        disabled={true}
                        />
                    </Grid> */}
        </Grid>

        <Grid  container size={12}>
          <Divider
            variant="fullWidth"
            sx={{ height: '1px', width: '80%', background: 'lightgray' }}
          />
        </Grid>
        <Grid  container size={12} rowGap={1} columnGap={1}>
          <Grid size={5}>
            <GreenButton
              label={t('print_debts_report')}
              fun={() => router('getDebtReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) || !Boolean(control.start_date)
              }
            />
          </Grid>
          <Grid size={5}>
            <GreenButton
              label={t('print_revenu_report')}
              fun={() => router('getOwerReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) || !Boolean(control.start_date)
              }
            />
          </Grid>
          <Grid size={5}>
            <GreenButton
              label={t('print_reciept_voucher_report')}
              fun={() => router('getRecieptVoucherReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) || !Boolean(control.start_date)
              }
            />
          </Grid>
          <Grid size={5}>
            <GreenButton
              label={t('print_payment_voucher_report')}
              fun={() => router('getPayVoucherReport')}
              fullWidth={true}
              disabled={
                !Boolean(control.end_date) || !Boolean(control.start_date)
              }
            />
          </Grid>
        </Grid>
        <Grid  container size={12}>

<Divider variant='fullWidth' sx={{height:'1px',width:'80%',background:'lightgray'}}    />
</Grid>
      </Grid>
    </Grid>
  );
};
